import { Autocomplete, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, Typography } from "@mui/material";
import { addTransactionsApi, getTransactionTypesApi, updateTransactionsApi } from "../apiService";
import { useEffect, useState } from "react";
import { checkApiStatus } from "../../../../utils";
import { globalGetService, globalPostService, globalPutService } from "../../../../utils/globalApiServices";
import { enqueueSnackbar } from "notistack";
import { trackActivity } from "../../../../utils/mixpanel";
import { regexConstants } from "../../../../constants/regEx";
import LessMoreTextFieldComp from "../../../../shared_elements/components/LessMoreTextFieldComp";
const CashFlowCategoriesTxnCRU = ({ onToggleModal, addEditTxn, getResponseBack, sortInfo, getSortingWiseData, modeType }) => {
    const [data, setData] = useState(addEditTxn?.data)
    const [existedTxn,setExistedTxn]=useState(modeType!=='add'?addEditTxn?.existedTxn.filter(option=>option!==data?.transaction_type?.id):addEditTxn?.existedTxn);
    const [transactionTypes, setTransactionTypes] = useState([]);
    const [dropDownloader, setDropDownLoader] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState({});
    useEffect(() => {
        addEditTxn?.mode !== 'view' && getTransactionTypes({type:addEditTxn?.cashflow_type});
    }, [])
    const onAddEditTransactions = () => {
        let validationInputs = {}
        validationInputs = {
            transaction_type: data?.transaction_type ? "" : "Please select Transaction Type",
            alias_name: data?.alias_name ? "" : "Please enter Alias Name",
        }
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === ""; })) {
            let payload = Object.assign({}, data);
            payload = {
                ...payload,
                transaction_type: data?.transaction_type?.id,
                category: data?.category?.id,
            };
            setLoading(true);
            if (payload.id) {
                globalPutService(updateTransactionsApi(), payload)
                    .then(async (response) => {
                        if (checkApiStatus(response)) {
                            if (sortInfo[data?.category?.id]?.sort) {
                                const newSort = sortInfo[data?.category?.id];
                                getSortingWiseData({ ...newSort, category_id: data?.category?.id }, data?.category?.id)
                            }
                            getResponseBack();
                            onToggleModal();
                            setLoading(false);
                            enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                            trackActivity('Item Edited', { page_title: `Edit Transaction`, success_msg: response?.data?.message, item_id: data?.id, payload: data, response: response?.data })
                        }
                        else {
                            setLoading(false);
                            enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                            trackActivity('Item Edited', { page_title: `Edit Transaction`, error_msg: response?.data?.message, item_id: data?.id, payload: data, response: response?.data })
                        }
                    })
            }
            else {
                globalPostService(addTransactionsApi(), payload).then(async (response) => {
                    if (checkApiStatus(response)) {
                        if (sortInfo[data?.category?.id]?.sort) {
                            const newSort = sortInfo[data?.category?.id];
                            getSortingWiseData({ ...newSort, category_id: data?.category?.id }, data?.category?.id)
                        }
                        onToggleModal();
                        getResponseBack();
                        setLoading(false);
                        enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        trackActivity('Item Added', { page_title: `Add Transaction`, success_msg: response?.data?.message, item_id: response?.data?.data?.id, payload: data, response: response?.data })
                    }
                    else {
                        setLoading(false);
                        enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, })
                        trackActivity('Item Added', { page_title: `Add Transaction`, error_msg: response?.data?.message, item_id: null, payload: data, response: response?.data })
                    }
                })
            }
        } else {
            setError(validationInputs);
            trackActivity(`Item ${modeType === 'add' ? 'Added' : 'Edited'}`, { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Transaction`, error_msg: validationInputs, })
        }
    }

    const getTransactionTypes = (query) => {
        setDropDownLoader(true)
        globalGetService(getTransactionTypesApi(query)).then(response => {
            setDropDownLoader(false)
            if (checkApiStatus(response)) {
                setTransactionTypes(response?.data?.data?.list);
            }
        })
    }
    const onFieldChange = (key, value) => {
        setData({ ...data, [key]: value });
    }
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Transaction`, page_type: page_type, })
    }
    return (
        <Dialog aria-labelledby="customized-dialog-title" className="add-lease-dialog" maxWidth="md" open={addEditTxn.modal} fullWidth>
            <DialogTitle sx={{ m: 0, p: 2 }} className='dialog-header'>
                <Typography className="dialog-header-title">
                    {modeType === "add" ? "Add" : modeType === "edit" ? "Edit" : "View "} Transaction
                </Typography>
            </DialogTitle>
            <DialogContent dividers>
                <Grid container spacing={2}>
                    <Grid size={{ md: 6, xs: 12 }}>
                        <Autocomplete
                            disablePortal
                            disableClearable
                            options={transactionTypes.filter(option=>!existedTxn.includes(option?.id)) || []}
                            getOptionLabel={(option) => option?.name || ""}
                            isOptionEqualToValue={(option, value) => option?.id === value?.id}
                            noOptionsText={dropDownloader ? "Loading..." : "No Option Available"}
                            value={data?.transaction_type || null}
                            onChange={(e, newValue) => onFieldChange('transaction_type', newValue)}
                            onFocus={() => setError({ ...error, transaction_type: '' })}
                            disabled={addEditTxn?.mode === 'view'}
                            slotProps={{
                                listbox: { style: { maxHeight: 140, overflowY: "auto" } },
                            }}
                            renderInput={(params) => <TextField {...params}
                                label='Transaction Type'
                                size="small" margin='normal'
                                variant="outlined" slotProps={{
                                    inputLabel: { shrink: true }, input: {
                                        ...params?.InputProps, endAdornment: (<>{dropDownloader ? (<CircularProgress color="inherit" size={20} />) : null}
                                            {params?.InputProps?.endAdornment}
                                        </>)
                                    }
                                }}
                                fullWidth required
                                error={error?.transaction_type} helperText={error?.transaction_type} placeholder='Select Transaction Type' />}
                        />
                    </Grid>
                    <Grid size={{ md: 6, xs: 12 }}>
                        <TextField disabled={addEditTxn?.mode === 'view'} label='Alias Name' size="small" value={data?.alias_name} onChange={(e) => regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange('alias_name', e.target.value.trimStart()) : e.preventDefault()} onFocus={() => setError({ ...error, alias_name: '' })} variant="outlined" slotProps={{ inputLabel: { shrink: true }, htmlInput: {maxLength: 100} }} fullWidth required error={error?.alias_name} helperText={error?.alias_name} />
                    </Grid>
                    {modeType === "view" ? <Grid item size={{ md: 12, xs: 12 }}>
                        <LessMoreTextFieldComp label='Remarks' value={data?.remarks || ""} />
                    </Grid> :
                        <Grid size={{ md: 12, xs: 12 }}>
                            <TextField 
                               disabled={addEditTxn?.mode === 'view'} 
                               label='Remarks' 
                               size="small" 
                               value={data?.remarks} 
                               onChange={(e) => onFieldChange('remarks', e.target.value.trimStart())} 
                               variant="outlined" 
                               slotProps={{ inputLabel: { shrink: true } }}
                               sx={{ '& .MuiInputBase-input': { resize: 'vertical', overflow: 'auto' } }}
                               fullWidth 
                               multiline 
                               rows={3} />
                        </Grid>}
                </Grid>
            </DialogContent>
            <DialogActions className="dialog-action">
                <Button className="cancel-btn" disabled={isLoading} variant="outlined" size="small" onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }}>{modeType === "view" ? "Close" : "Cancel"}</Button>
                {modeType === "view" ? null :
                <Button className="btn-primary" variant="contained" size="small" onClick={() => { handleItemClicked('Save Button'); onAddEditTransactions() }}>{isLoading ? <CircularProgress color="inherit" size={25} /> : "Save"}</Button>}
            </DialogActions>
        </Dialog>
    )
}
export default CashFlowCategoriesTxnCRU;